import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import BenefitsAndTechnology from "./sections/BenefitsAndTechnology";
import FourStepMethod from "./sections/FourStepMethod";
import OurServicesOverview from "./sections/OurServicesOverview";
import FreeDiagnosisCta from "./sections/FreeDiagnosisCta";
import Footer from "@/reusable_sections/Footer";
import PoliticaDePrivacidad from "./sections/PoliticaDePrivacidad";
import PrivacyPolicySection from "./sections/PrivacyPolicySection";
import SeccionLegal from "./sections/SeccionLegal";
import TerminosYCondiciones from "./sections/TerminosYCondiciones";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <BenefitsAndTechnology />
      <FourStepMethod />
      <OurServicesOverview />
      <FreeDiagnosisCta />
      <TerminosYCondiciones />
      <SeccionLegal />
      <PrivacyPolicySection />
      <PoliticaDePrivacidad />
      <Footer />
    </div>;
}